import {
  Text,
  createStyles,
  Paper,
  Badge,
  Group,
  Box,
  TypographyStylesProvider,
  Flex, rem,
} from "@mantine/core"
import { Image } from "shared/ui/Image"
import { fDate } from "shared/lib/dates"
import { categoryNames } from "shared/lib/constants"
import { type Article } from "shared/types/article"
import { API_URL } from "shared/config"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  container: {
    gap: rem(48),

    [theme.fn.smallerThan("xl")]: {
      gap: rem(24),
    },

    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
    },
  },

  paper: {
    width: "calc(65% - 24px)",
    padding: rem(48),
    boxShadow: theme.shadows.light,

    [theme.fn.smallerThan("xl")]: {
      padding: rem(24),
    },

    [theme.fn.smallerThan("sm")]: {
      boxShadow: "none",
      padding: 0,
      width: "100%",
      order: 1,
    },
  },

  image: {
    width: "calc(35% - 24px)",
    borderRadius: theme.radius.xl,

    [theme.fn.smallerThan("sm")]: {
      order: 0,
      width: "100%",
    },
  },

  textContent: {
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
  },
}))

// ----------------------------------------------------------------------

export function ArticleDetails({ title, textContent, cover, createdAt, category }: Article): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Flex align="flex-start" className={classes.container}>
      <Paper radius="xl" className={classes.paper}>
        <Flex direction="column">
          <Group>
            <Text transform="capitalize" c="dimmed">
              {fDate(createdAt)}
            </Text>
            <Badge gradient={{ from: "orange", to: "red" }} variant="gradient" size="lg">
              {categoryNames[category]}
            </Badge>
          </Group>

          <TypographyStylesProvider mt="xl">
            <Box className={classes.textContent} dangerouslySetInnerHTML={{ __html: textContent }}/>
          </TypographyStylesProvider>
        </Flex>
      </Paper>
      <Image src={`${API_URL}/media/${cover}`} alt={title} className={classes.image}/>
    </Flex>
  )
}
